import {
    Animations,
    Geometries,
    Interactions,
    Layers,
    Map,
    MapControls,
    Sources,
    Styles
  } from "vue3-openlayers"
  import type { App } from 'vue'
  
  // Массив компонентов OpenLayers для регистрации
  const openLayersComponents = [
    Map,
    Layers,
    Sources,
    Geometries,
    Styles,
    MapControls,
    Interactions,
    Animations
  ]
  
  /**
   * Регистрирует все компоненты OpenLayers в приложении Vue
   * @param app - Экземпляр приложения Vue
   */
  export function registerOpenLayers(app: App) {
    openLayersComponents.forEach(component => {
      app.use(component)
    })
  }